(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vilicci-mega-nav"] && !Shopify.designMode) return;
  try {
    
(function(){
  var nav=document.querySelector('.vmn');
  if(!nav)return;
  var burger=nav.querySelector('.vmn__burger');
  var drawer=nav.querySelector('.vmn__drawer');
  var scrim=nav.querySelector('.vmn__scrim');
  var closeBtn=nav.querySelector('.vmn__close');
  function openDrawer(v){
    drawer.hidden=!v;scrim.hidden=!v;
    requestAnimationFrame(function(){drawer.classList.toggle('is-open',v)});
    burger.setAttribute('aria-expanded',v?'true':'false');
  }
  burger&&burger.addEventListener('click',function(){openDrawer(true)});
  closeBtn&&closeBtn.addEventListener('click',function(){openDrawer(false)});
  scrim&&scrim.addEventListener('click',function(){openDrawer(false)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')openDrawer(false)});
})();

  } catch(e) { console.error(e); }
})();
})();
